module.exports = __webpack_public_path__ + "static/project_haven-d9b3c7b188c8c2b613d52ee1a08265f1.png";